export default __webpack_public_path__ + "static/media/AVANTIKA.4060a58e.JPG";